import { getRenderedLocale } from "./locale";

export function triggerGoogleTagManagerCustomEvent(
  event: string,
  metadata?: object,
): void {
  // There is no dataLayer to reach without a document, so a deferred dispatch
  // that lands during SSR — or after a test environment is torn down — has
  // nothing to do rather than something to fail at.
  if (typeof window === "undefined") return;
  // Spread first so a caller that captured the locale at interaction time wins
  // over this read, which happens whenever the dispatch lands.
  const renderedLocale = getRenderedLocale();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    custom_event_metadata: renderedLocale
      ? { locale_rendered: renderedLocale, ...metadata }
      : metadata,
  });
}

export const GoogleTagManagerCustomEvents: Record<string, string> = {
  experimentImpression: "experiment_impression",
  marketoFormSubmitted: "marketo-form-submitted",
  ffdeTabSwitch: "FFDE_TAB_SWITCH",
  ffdeIndustrySelect: "FFDE_INDUSTRY_SELECT",
  ctaClick: "cta_click",
};
